"use strict";
exports.__esModule = true;
exports.AmplitudeFeatureFlag = void 0;
var AmplitudeFeatureFlag;
(function (AmplitudeFeatureFlag) {
    AmplitudeFeatureFlag["AddFunds"] = "add-funds-to-wallet";
    AmplitudeFeatureFlag["ChatbotInApp"] = "chatbot-in-app";
    AmplitudeFeatureFlag["Deeplinking"] = "deeplinking";
    AmplitudeFeatureFlag["EnableIterable"] = "enable-iterable";
    AmplitudeFeatureFlag["OCIterableAPI"] = "oc-iterable-api";
    AmplitudeFeatureFlag["EnableSprig"] = "enable-sprig";
    AmplitudeFeatureFlag["ForceUpgradeRequired"] = "force-upgrade-required";
    AmplitudeFeatureFlag["InAppReview"] = "in-app-review";
    AmplitudeFeatureFlag["OutstandingPartialPayments"] = "outstanding-partial-payments";
    AmplitudeFeatureFlag["PartialPayments"] = "partial-payments";
    AmplitudeFeatureFlag["PauseUpdates"] = "pause-updates";
    AmplitudeFeatureFlag["PaymentScheduleRefactor"] = "payment-schedule-refactor";
    AmplitudeFeatureFlag["PropertyNameEnabled"] = "property-name-enabled";
    AmplitudeFeatureFlag["RentReportingEquifax"] = "rent-reporting-equifax";
    AmplitudeFeatureFlag["RentReportingExperian"] = "rent-reporting-experian";
    AmplitudeFeatureFlag["RequiredAgreements"] = "required-agreements";
    AmplitudeFeatureFlag["RelinkToOON"] = "relink-to-oon";
    AmplitudeFeatureFlag["ZeroBalanceDispositionHandling"] = "zero-balance-disposition-handling";
    AmplitudeFeatureFlag["PaymentStatusRefactorSeptBP"] = "payment-status-sept-bp";
    AmplitudeFeatureFlag["PaymentStatusMigrationFF"] = "ff-payment-status-migration-oct-bp-2024";
    AmplitudeFeatureFlag["SLCAgreementTerms"] = "slc-agreement-terms";
    AmplitudeFeatureFlag["RentPaymentBreakdownFF"] = "ff-rent-payment-breakdown-oct-bp-2024";
    AmplitudeFeatureFlag["FlexAnywherePaymentStatusMigrationFF"] = "ff-fa-payment-status-migration-oct-bp-2024";
    AmplitudeFeatureFlag["ConsentManagementKillSwitch"] = "transcend-consent-mgmt";
    AmplitudeFeatureFlag["PortalCredentialsUpdate"] = "portal-credentials-update";
    AmplitudeFeatureFlag["UseV2RentAmountSurvey"] = "use-v2-rent-amount-survey";
    AmplitudeFeatureFlag["SuggestAFridayModal"] = "suggest-a-friday-reschedule-modal";
    AmplitudeFeatureFlag["SDKEmbedKillSwitch"] = "sdk-embed-kill-switch";
    AmplitudeFeatureFlag["PaymentStatusRefactorJanBP"] = "payment-status-refactor-jan-bp";
    AmplitudeFeatureFlag["YardiEmbedMarchBP"] = "yardi_embed_march_bp_hiw_cta";
    AmplitudeFeatureFlag["EpisodicCalendarFF"] = "ff-episodic-calendar-feb";
    AmplitudeFeatureFlag["PaymentStatusRefactorMidFeb"] = "payment-status-refactor-mid-feb-2024";
    AmplitudeFeatureFlag["SingularDeeplinking"] = "singular-deeplinking";
    AmplitudeFeatureFlag["DocVWeb"] = "docv-web";
    AmplitudeFeatureFlag["DocVMobile"] = "docv-mobile";
    AmplitudeFeatureFlag["PaymentStatusRefactorMarch"] = "payment-status-refactor-march-2025";
    AmplitudeFeatureFlag["PaymentStatusRefactorOnboardingMarch"] = "payment-status-refactor-onboarding-march-2025";
    AmplitudeFeatureFlag["ResumeOnboardingSkipped"] = "resume-onboarding-skipped";
    AmplitudeFeatureFlag["UpdateCreditUtilizationZeroMinimum"] = "update-credit-utilization-zero-minimum";
    AmplitudeFeatureFlag["AprilBpConsolidateCardScreen"] = "april-bp-consolidate-card-screen";
    AmplitudeFeatureFlag["AprilBpResumeOnboardingSkipped"] = "april_bp_resume_onboarding_skipped";
    AmplitudeFeatureFlag["MayBpSkipSmsOptIn"] = "may_bp_skip_sms_opt_in";
    AmplitudeFeatureFlag["MayBpSoftCreditCheck"] = "may_bp_soft_credit_check";
    AmplitudeFeatureFlag["EnableGoogleTagManager"] = "consumer-marketing-tags";
    AmplitudeFeatureFlag["RXPUpdateCreditUtilizationZeroMinimum"] = "rxp-update-credit-utilization-zero-minimum";
    AmplitudeFeatureFlag["DocVRXP"] = "docv-rxp";
    AmplitudeFeatureFlag["MoveIn"] = "move-in";
    AmplitudeFeatureFlag["MoveInBillPull"] = "move-in-bill-pull";
    AmplitudeFeatureFlag["MoveInV2"] = "move-in-v2";
    AmplitudeFeatureFlag["ToggleNextMonth"] = "toggle-next-month-june-2025";
    AmplitudeFeatureFlag["WebBackNavigation"] = "web-back-navigation";
    AmplitudeFeatureFlag["CreditBuilderPreApproval"] = "credit-builder-pre-approval";
    AmplitudeFeatureFlag["PropertyAddressFallback"] = "property-address-fallback";
    AmplitudeFeatureFlag["P2PRelinkFF"] = "p2p-relink-ff";
    AmplitudeFeatureFlag["P2PReapplyFF"] = "p2p-reapply-ff";
    AmplitudeFeatureFlag["RepaymentsCdqUx"] = "repayments-cdq-ux";
    AmplitudeFeatureFlag["AugustMakePaymentMMF"] = "make-payment-mmf-mid-august-2025";
})(AmplitudeFeatureFlag = exports.AmplitudeFeatureFlag || (exports.AmplitudeFeatureFlag = {}));
